import { useMemo } from "react";
import type { DateRange } from "react-day-picker";
import type { DateBounds } from "../types";
import { maxRangeSlidingWindow } from "../utils/maxRangeSlidingWindow";

export function useMaxRangeWindow(
  selected: DateRange | undefined,
  days?: number,
): DateBounds {
  return useMemo(() => maxRangeSlidingWindow(selected, days), [selected, days]);
}
